module.exports = __webpack_public_path__ + "static/media/black.1666ee87.svg";